import { useEffect, useRef, useState } from 'react';
import { renderAsync } from 'docx-preview';

type DOCXViewerProps = {
  fileUrl?: string;
};

export function DOCXViewer({ fileUrl }: DOCXViewerProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [localFileUrl, setLocalFileUrl] = useState<string | null>(null);

  const activeFileUrl = fileUrl ?? localFileUrl;

  useEffect(() => {
    if (!activeFileUrl) return;

    const loadDocx = async () => {
      const response = await fetch(activeFileUrl);
      const buffer = await response.arrayBuffer();
      await renderAsync(buffer, containerRef.current!);
    };

    loadDocx();
  }, [activeFileUrl]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const blobUrl = URL.createObjectURL(file);
      setLocalFileUrl(blobUrl);
    }
  };

  if (!activeFileUrl) {
    return (
      <div>
        <input type="file" accept=".docx" onChange={handleFileChange} />
        <p>DOCX</p>
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      className="h-full overflow-auto p-4 border border-gray-200 rounded-lg bg-white"
    />
  );
}
